import { getPointBalance } from "@/services/user/getPointBalance";
import { getDomain } from "@/services/getDomain";
import { getProgram } from "@/services/program/getProgram";
import store from "@/containers/App/store";
import { setStoreProgram } from "@/redux/actions/programActions";
import {v3GetCookie, v3SetCookie, v3DeleteCookie} from "../../shared/helpers";
import { rateLimitStore } from './../../containers/App/rateLimitStore';

export const AUTH_USER_KEY = "authUser";
export const AUTH_TOKEN_KEY = "authToken";
export const AUTH_POINTS_KEY = "authPoints";
export const AUTH_PROGRAM_KEY = "authProgram";
export const AUTH_CURRENCY_KEY = "authCurrency";
export const AUTH_COUNTRY_KEY = "authCountry";
export const AUTH_ROOT_PROGRAM_KEY = "authRootProgram";
export const AUTH_ORGANIZATION_KEY = "authOrganization";
export const AUTH_CART = "authCart";
export const AUTH_DOMAIN_KEY = "icoDomain";
export const AUTH_THEME = "icoTheme";
export const AUTH_SELECT_PROGRAM_TREE = "authSelectProgramTree";
export const DEFAULT_TEMPLATE = {
  big_logo: `logo/big_logo.png`,
  small_logo: `logo/small_logo.png`,
  welcome_message: `Welcome to INCENTCO's Global Solutions rewards site! When you participate in our program, you'll earn rewards for various activities.`,
};
export const AUTH_LOGIN_AS = 'authLoginAsBanner';

export const login = async(data) => {
  const now = new Date();
  const item = {
    key: data.access_token,
    expiry: now.getTime() + 8 * 60 * 60 * 1000,
  }

  localStorage.setItem(AUTH_TOKEN_KEY, JSON.stringify(item));
  v3SetCookie('isAuthenticated', 'yes');

  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(data.user));
  localStorage.setItem(
    AUTH_ORGANIZATION_KEY,
    JSON.stringify(data.organization)
  );
  localStorage.setItem(AUTH_PROGRAM_KEY, JSON.stringify(data.program));
  localStorage.setItem(AUTH_ROOT_PROGRAM_KEY, JSON.stringify(data.program));
  data.loginAsBanner && setLoginAs(data.loginAsBanner);
}

export const logout = (isIdle = false) => {
  flushUserSession();
  window.location = "/login";
};

export const flushUserSession = async () => {
  localStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem(AUTH_TOKEN_KEY);
  v3DeleteCookie('isAuthenticated');
  localStorage.removeItem(AUTH_ORGANIZATION_KEY);
  localStorage.removeItem(AUTH_PROGRAM_KEY);
  localStorage.removeItem(AUTH_ROOT_PROGRAM_KEY);
  localStorage.removeItem(AUTH_POINTS_KEY);
  localStorage.removeItem(AUTH_CART);
  localStorage.removeItem(AUTH_DOMAIN_KEY);
  localStorage.removeItem(AUTH_SELECT_PROGRAM_TREE);
  localStorage.removeItem('SELECT_PROGRAM_TREE'); //tmp, remove
  localStorage.removeItem(AUTH_LOGIN_AS)
};

export const isAuthenticated = () => {
  // localStorage.removeItem(AUTH_POINTS_KEY);
  // flushUserSession();
  const itemStr = localStorage.getItem(AUTH_TOKEN_KEY);
  const cookieCheck = v3GetCookie('isAuthenticated');

  if (cookieCheck && itemStr) {
    let item = null;
    try {
      item = JSON.parse(itemStr)
    } catch (e) {
      return false;
    }
    const now = new Date()
    if (now.getTime() > item.expiry) {
      flushUserSession();
    } else {
      const now = new Date();
      const refreshItem = {
        key: item.key,
        expiry: now.getTime() + 8 * 60 * 60 * 1000,
      }
      localStorage.setItem(AUTH_TOKEN_KEY, JSON.stringify(refreshItem));

      // console.log(getAuthUser())
      return true;
    }
  }
  return false;
};

export const getToken = () => {
  const itemStr = localStorage.getItem(AUTH_TOKEN_KEY);
  if (itemStr) {
    let item = null;
    try {
      item = JSON.parse(itemStr)
    } catch (e) {
      return null;
    }
    return item.key;
  }
  return null;
};

export const getAuthProgram = ( hydrate = false ) => {
  let program = JSON.parse(localStorage.getItem(AUTH_PROGRAM_KEY)) ?? {};  
  if (!program) {
    console.warn("No auth program found in localStorage.");
    return null; 
  }
  // console.log("getAuthProgram")
  if( hydrate ) {
    return getProgram( program.organization_id, program.id )
    .then( p => {
        if (p?.error_code === 'rate_limit_exceeded') {
            rateLimitStore.set({
            active: true,
            message: p.message,
            retryAfter: p.retry_after,
            });

            if (p.retry_after) {
                setTimeout(() => {
                rateLimitStore.set({ active: false, message: '' });
                }, p.retry_after * 1000);
            }
            store.dispatch(setStoreProgram(program));
        } else {
            setAuthProgram(p)
            store.dispatch(setStoreProgram(p));
            return p;
        }
      //return p
    })
  } else {
    store.dispatch(setStoreProgram(program));
  }
  return program
};

export const getTheme = () => {
  return JSON.parse(localStorage.getItem(AUTH_THEME));
};

export const setTheme = ( theme ) => {
  localStorage.setItem(AUTH_THEME, JSON.stringify(theme));
};

export const getAuthRootProgram = () => {
  return JSON.parse(localStorage.getItem(AUTH_ROOT_PROGRAM_KEY));
};

export const setAuthPoints = (points) => {
  localStorage.setItem(AUTH_POINTS_KEY, JSON.stringify(points));
};

export const getAuthPoints = async () => {
  // let storagePoints = localStorage.getItem(AUTH_POINTS_KEY)
  // // console.log(storagePoints)
  // // console.log(storagePoints!=='undefined' && storagePoints)
  // if( storagePoints!=='undefined' && storagePoints ) {
  //     // console.log(storagePoints)
  //     return JSON.parse(storagePoints)
  // }
  return hydratePointBalance();
};

export const hydratePointBalance = () => {
  const authOrg = getOrganization();
  const authProgram = getAuthProgram();
  const authUser = getAuthUser();
  if (!authUser) return;
  return getPointBalance(authOrg.id, authProgram.id, authUser.id).then(
    (points) => {
      // console.log(points)
      setAuthPoints(points);
      return points;
    }
  );
};

export const setAuthProgram = (program) => {
  return localStorage.setItem(AUTH_PROGRAM_KEY, JSON.stringify(program));
};

export const setAuthCurrency = (currency) => {
  return localStorage.setItem(AUTH_CURRENCY_KEY, JSON.stringify(currency));
};

export const getAuthCurrency = () => {
  try {
    const authCurrency = JSON.parse(localStorage.getItem(AUTH_CURRENCY_KEY));
    // console.log(authCurrency)
    return authCurrency;
  } catch (e) {
    return null;
  }
};

export const setAuthCountry = (country) => {
  return localStorage.setItem(AUTH_COUNTRY_KEY, JSON.stringify(country));
};

export const getAuthCountry = () => {
  try {
    const authCountry = JSON.parse(localStorage.getItem(AUTH_COUNTRY_KEY));
    // console.log(authCurrency)
    return authCountry;
  } catch (e) {
    return null;
  }
};

// export const getAuthProgram = async( hydrate = false ) => {
//   // flushUserSession();
//   // return;
//   // localStorage.removeItem(AUTH_PROGRAM_KEY);
//   const authProgram = localStorage.getItem(AUTH_PROGRAM_KEY)
//   console.log(authProgram)
//   console.log(typeof authProgram)
//   let program;
//   if( authProgram ) {
//     program = JSON.parse(authProgram)
//     console.log("program")
//     console.log(program)
//   }
//   if( !hydrate ) {
//     return program;
//   }
//   if( hydrate && !program?.id )  {
//     console.log("Invalid request found")
//   }

//   if( hydrate ) {
//     program = getProgram(program.organization_id, program.id)
//     console.log("program in auth.jsx > getAuthProgram")
//     console.log(program)
//     setAuthProgram( program )
//     return program
//   }
// }

export const getBearer = () => {
  // console.log(getAuthUser())
  const AuthToken = getToken();
  // console.log(AuthToken)
  return AuthToken ? "Bearer " + AuthToken : null;
};

export const getAuthUser = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem(AUTH_USER_KEY));
    // console.log(authUser)
    return authUser;
  } catch (e) {
    return null;
  }
};

export const setAuthDomain = (domain) => {
  localStorage.setItem(AUTH_DOMAIN_KEY, JSON.stringify(domain));
};

export const getAuthDomain = async (hydrate = false) => {
  // localStorage.removeItem(AUTH_DOMAIN_KEY);
  const storageDomain = localStorage.getItem(AUTH_DOMAIN_KEY);
  if (hydrate || !storageDomain) return hydrateDomain();
  return JSON.parse(storageDomain);
};

export const hydrateDomain = () => {
    // const host = window.location.host
    // let domainName = host
    // if(host.indexOf(':') !== -1)    {
    //     const pieces = host.split(':')
    //     domainName = pieces[0]
    // }
    return getDomain()
    .then( domain => {
        // console.log(domain)
        if( domain?.program && !domain.program.template) {
            domain.program.template = DEFAULT_TEMPLATE
        }
        setAuthDomain(domain)
        return domain
    }).catch( err => {
        alert(err)
    })
    .catch((err) => {
      alert(err);
    });
};

export const getOrganization = () => {
  //get from AuthUser TODO
  // return ORGANIZATION
  return JSON.parse(localStorage.getItem(AUTH_ORGANIZATION_KEY));
};
export const getAuthUserFullname = () => {
  const user = getAuthUser();
  // console.log(isVerified())
  if (user) return `${user.first_name} ${user.last_name}`;
};

export const asyncLocalStorage = {
  setItem: async function (key, value) {
    await null;
    return localStorage.setItem(key, value);
  },
  getItem: async function (key) {
    await null;
    return localStorage.getItem(key);
  },
};

export const getAuthCart = () => {
  // localStorage.removeItem(AUTH_CART);
  const cartdata = localStorage.getItem(AUTH_CART);
  if (cartdata !== null) {
    let acart = JSON.parse(cartdata);
    return acart;
  } else return null;
};

export const updateAuthCart = (datacart) => {
  localStorage.setItem(AUTH_CART, JSON.stringify(datacart));
  return true;
};

export const emptyAuthCart = () => {
  localStorage.removeItem(AUTH_CART);
};

export const getLoginAs = () => {
  return JSON.parse(localStorage.getItem(AUTH_LOGIN_AS));
};

export const setLoginAs = (data) => {
  const loginAs = getLoginAs()
  return localStorage.setItem(AUTH_LOGIN_AS, JSON.stringify({ ...loginAs, ...data }));
};